<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title> Manage Options </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              hide-default-header
              :items="optionalInclusions"
              hide-default-footer
              disable-sort
            >
              <template v-slot:item.name="{ item }">
                <v-list-item two-line class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle
                      class="text-underline cursor-pointer"
                      @click="showMultiConnectVideo = true"
                      >Learn more</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip
                  v-if="item.isAddedToPlan"
                  color="green"
                  label
                  dark
                  small
                  >{{ item.status }}</v-chip
                >
              </template>
              <template v-slot:item.actions="{ item }">
                <v-menu
                  transition="slide-y-transition"
                  bottom
                  left
                  offset-y
                  v-if="item.isAddedToPlan"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list nav>
                    <v-list-item @click="handleCancelClick">
                      <v-list-item-title>Cancel inclusion</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn
                  v-else
                  color="primary"
                  text
                  @click="handleAddToPlan(item)"
                  >Add to plan</v-btn
                >
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="showCancelDialog" persistent max-width="500" eager>
      <v-card :loading="updatePlanLoadingDialog">
        <v-card-title class="justify-space-between">
          Cancel EventConnect?
          <v-btn fab text small @click="showCancelDialog = false"
            ><v-icon class="text-right text--secondary">close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text v-html="cancelMultiConnectContent"></v-card-text>
        <v-card-actions class="mx-4">
          <v-row>
            <v-col class="pt-5">
              <v-btn
                large
                elevation="0"
                color="primary"
                block
                @click="handleCancelMCAddOn"
              >
                Cancel EventConnect
              </v-btn>
              <v-btn
                class="mt-2 text-body-1"
                large
                text
                elevation="0"
                color="primary"
                block
                @click="showCancelDialog = false"
              >
                Not now
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showAddToPlanDialog"
      persistent
      max-width="500"
      eager
      v-if="selectedInclusion"
    >
      <v-card :loading="updatePlanLoadingDialog">
        <v-card-title class="justify-space-between">
          Add {{ selectedInclusion.name }} to your plan?
          <v-btn fab text small @click="showAddToPlanDialog = false"
            ><v-icon class="text-right text--secondary">close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <p v-if="selectedInclusion.name">
            You can start using {{ selectedInclusion.name }} today and we will
            adjust the price accordingly in your next billing.
          </p>

          <v-row class="pb-0">
            <v-col class="pt-5 pb-0" v-if="selectedInclusion.name">
              <v-btn
                large
                elevation="0"
                color="primary"
                block
                @click="handleAddMCToPlan"
              >
                Add {{ selectedInclusion.name }} to my plan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <MultiConnectVideo
      :show="showMultiConnectVideo"
      @close="showMultiConnectVideo = false"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Utility from "@/shared/utility";
import MultiConnectVideo from "@/components/MultiConnect/MultiConnectVideo";
import {getHttpsCallable} from "@/shared/firebase_utils";


export default {
  components: {
    MultiConnectVideo,
  },
  created() {
    this.formatDate = Utility.formatDate;
    this.initOptionalInclusions();
  },
  data() {
    return {
      updatePlanLoadingDialog: false,
      breadcrumbItems: [
        {
          text: "Home",
          disabled: false,
          to: "/",
        },
        {
          text: "Manage Subscriptions",
          disabled: false,
          to: "/manageSubscription",
        },
        {
          text: "Manage Options",
          disabled: true,
        },
      ],
      optionalInclusions: [
        {
          name: "EventConnect",
          amount: "$10/mo",
          status: "Active",
          isAddedToPlan: false,
        },
        // {
        //   name: "Business Card Prize Draw",
        //   amount: "$9.95/mo",
        //   status: "Active",
        //   isAddedToPlan: false,
        // },
      ],
      headers: [
        {
          text: "",
          value: "name",
          align: "start",
        },
        {
          text: "",
          value: "amount",
          align: "start",
        },
        {
          text: "",
          value: "status",
          align: "start",
        },
        {
          text: "",
          value: "actions",
          align: "end",
        },
      ],
      showCancelDialog: false,
      showAddToPlanDialog: false,
      selectedInclusion: {},
      formatDate: null,
      showMultiConnectVideo: false,
    };
  },
  watch: {
    currentSubscriptionPlan: function () {
      this.initOptionalInclusions();
    },
  },
  computed: {
    ...mapGetters(["hasUpcomingEvents", "businessProfile", "upcomingEvents"]),
    cancelMultiConnectContent() {
      if (this.upcomingEvents.length > 0) {
        return `<p>The events you have created after your current billing period ends on ${this.formatDate(
          this.businessProfile.nextInvoiceCreationDate.toDate()
        )}  will be deactivated but you will continue to have access to your past EventConnect events.</p>`;
      } else {
        return `<p>You will not be able to create new events after your current billing period ends on ${this.formatDate(
          this.businessProfile.nextInvoiceCreationDate.toDate()
        )}  but you will continue to have access to your past EventConnect events. </p>
            <p>We will adjust the price accordingly in your next billing.</p>`;
      }
    },
    currentSubscriptionPlan() {
      return this.businessProfile.plan;
    },
  },
  methods: {
    ...mapActions(["showSnackbar", "updateBusinessProfileDetails"]),
    handleCancelClick() {
      this.showCancelDialog = true;
    },
    handleAddToPlan(inclusion) {
      this.selectedInclusion = inclusion;
      this.showAddToPlanDialog = true;
    },
    async handleAddMCToPlan() {
      //This method should switch a grow plan to evolve plan
      await this.changeSubscriptionPlan("evolve");
      this.showAddToPlanDialog = false;
      this.showSnackbar({
        show: true,
        text: "EventConnect added to plan successfully!",
      });
    },
    async changeSubscriptionPlan(plan) {
      console.log("changeSubscriptionPlan");
      if (this.updatePlanLoadingDialog) return;
      try {
        this.updatePlanLoadingDialog = true;
        const changeSubscriptionPlan = getHttpsCallable("changeSubscriptionPlan");
        const response = await changeSubscriptionPlan({
          subscriptionId: this.businessProfile.subscriptionId,
          billingPeriod: this.businessProfile.billingPeriod,
          plan: plan,
          quantity: this.businessProfile.noOfEmployees,
        });
        if (response.data.error != undefined) {
          console.log(
            "Error while calling the changeSubscriptionPlan cloud function"
          );
          console.log(response.data.error);
        } else {
          const subscription = response.data;
          if (
            subscription.status === "active" ||
            subscription.status === "trialing" ||
            subscription.status === "past_due"
          ) {
            //Update the Business Profile
            console.log(subscription);
            await this.updateBusinessProfileDetails({
              subscriptionStatus: subscription.status,
              plan: plan,
            });
          }
        }
        this.updatePlanLoadingDialog = false;
      } catch (error) {
        this.updatePlanLoadingDialog = false;
        console.log(error);
      }
    },
    async handleCancelMCAddOn() {
      //This method should switch the evolve plan to grow plan
      //Make sure to include the code for expiring all active or upcoming events from subscriptionUpdated cloud function
      await this.changeSubscriptionPlan("grow");
      this.showCancelDialog = false;
      this.showSnackbar({
        show: true,
        text: "EventConnect add-on cancelled successfully!",
      });
    },
    initOptionalInclusions() {
      let optionalInclusionObject = [
        {
          ...this.optionalInclusions[0],
          isAddedToPlan:
            this.currentSubscriptionPlan == "evolve" ? true : false,
        },
      ];
      this.optionalInclusions = optionalInclusionObject;
    },
  },
};
</script>

<style></style>
